import { Box } from '@material-ui/core';
import { useSelector } from 'dva';
import { useMemo } from 'react';
// import TooltipML from '../../user_behavior_detail/components/Tooltip';

export default () => {
  const { dataOverview } = useSelector((state) => state.behaviorData) || {};

  const dataOverviewList = useMemo(() => {
    const {
      userNum,
      userNumChange,
      signNum,
      signNumChange,
      bookPageNum,
      bookPageNumChange,
      visitTimeTotal,
      visitTimeTotalChange,
      behaveNum,
      behaveNumChange,
    } = dataOverview || {};

    return [
      {
        label: '用户量',
        number: userNum,
        trendNumber: userNumChange,
        icon: require('@/assets/img/bizgrowth/member.png'),
      },
      {
        label: '登陆次数',
        number: signNum,
        trendNumber: signNumChange,
        icon: require('@/assets/img/bizgrowth/activeMember.png'),
      },
      {
        label: '页面浏览量',
        number: bookPageNum,
        trendNumber: bookPageNumChange,
        icon: require('@/assets/img/bizgrowth/activeMember.png'),
      },
      {
        label: '曝光时长',
        number: visitTimeTotal,
        trendNumber: visitTimeTotalChange,
        icon: require('@/assets/img/bizgrowth/activeMember.png'),
      },
      {
        label: '日行为事件数',
        number: behaveNum,
        trendNumber: behaveNumChange,
        icon: require('@/assets/img/bizgrowth/activeMember.png'),
      },
    ];
  }, [dataOverview]);

  return (
    <Box>
      <Box display="flex" flex="1">
        今日行为数据概览
        {/* <TooltipML info="这里是一段文字描述" /> */}
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gridGap: '24px',
          marginTop: '24px',
        }}
      >
        {dataOverviewList.map((item, index) => {
          return (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flex: '1',
                paddingRight:
                  index !== dataOverviewList.length - 1 ? '24px' : '0',
                borderRight:
                  index !== dataOverviewList.length - 1
                    ? '1px solid #F2F2F2'
                    : '',
              }}
            >
              {/* 左 */}
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <img
                  style={{ width: '46px', height: '46px' }}
                  src={item.icon}
                  alt=""
                />
                <Box sx={{ marginTop: '6px', color: 'rgb(58, 58, 58)' }}>
                  {item.label}
                </Box>
              </Box>
              {/* 右↓ */}
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box
                  sx={{
                    color: 'rgb(21, 101, 192)',
                    fontSize: '22px',
                    fontWeight: 'bold',
                  }}
                >
                  {item.number}
                </Box>
                <Box
                  sx={{
                    color: `${
                      item.trendNumber < 0 ? 'green' : 'rgb(210, 133, 88)'
                    }`,
                    fontSize: '14px',
                    height: '14px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <span>{Math.abs(item.trendNumber || 0)}</span>
                  <span>%</span>
                  <span
                    style={{
                      marginTop: '-3px',
                    }}
                  >
                    {item.trendNumber < 0 ? '↓' : '↑'}
                  </span>
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
